export const classifWorkData = {
  CEO: [
    {
      id: "9",
      name: "Other",
    },
  ],
  BD: [
    {
      id: "2",
      name: "Department Work",
    },
    {
      id: "9",
      name: "Other",
    },
  ],
  CS: [
    {
      id: "2",
      name: "Department Work",
    },
    {
      id: "9",
      name: "Other",
    },
  ],
  CO: [
    {
      id: "1",
      name: "Project",
    },
    {
      id: "9",
      name: "Other",
    },
  ],
  DM: [
    {
      id: "1",
      name: "Project",
    },
    {
      id: "9",
      name: "Other",
    },
  ],
  MW: [
    {
      id: "1",
      name: "Project",
    },
    {
      id: "9",
      name: "Other",
    },
  ],
  OF: [
    {
      id: "2",
      name: "Department Work",
    },
    {
      id: "9",
      name: "Other",
    },
  ],
  SA: [
    {
      id: "1",
      name: "Project",
    },
    {
      id: "9",
      name: "Other",
    },
  ],
  SRD: [
    {
      id: "2",
      name: "Department Work",
    },
    {
      id: "9",
      name: "Other",
    },
  ],
  RA: [
    {
      id: "1",
      name: "Project",
    },
    {
      id: "9",
      name: "Other",
    },
  ],
};

// export const classifWorkData = [
//   {
//     id: "1",
//     name: "Project",
//   },
//   {
//     id: "2",
//     name: "Department Work",
//   },
//   {
//     id: "9",
//     name: "Other",
//   },
// ];

export const durationData = [
  {
    id: 1,
    name: "1h",
  },
  {
    id: 2,
    name: "2h",
  },
  {
    id: 3,
    name: "3h",
  },
  {
    id: 4,
    name: "4h",
  },
  {
    id: 5,
    name: "5h",
  },
  {
    id: 6,
    name: "6h",
  },
  {
    id: 7,
    name: "7h",
  },
  {
    id: 8,
    name: "8h",
  },
];

// export const data = [
//   {
//     text: "Website Re-Design Plan",
//     startDate: new Date("2021-04-26T16:30:00.000Z"),
//     endDate: new Date("2021-04-26T18:30:00.000Z"),
//   },
//   {
//     text: "Book Flights to San Fran for Sales Trip",
//     startDate: new Date("2021-04-26T19:00:00.000Z"),
//     endDate: new Date("2021-04-26T20:00:00.000Z"),
//     allDay: true,
//   },
//   {
//     text: "Install New Router in Dev Room",
//     startDate: new Date("2021-04-26T21:30:00.000Z"),
//     endDate: new Date("2021-04-26T22:30:00.000Z"),
//   },
//   {
//     text: "Approve Personal Computer Upgrade Plan",
//     startDate: new Date("2021-04-27T17:00:00.000Z"),
//     endDate: new Date("2021-04-27T18:00:00.000Z"),
//   },
//   {
//     text: "Final Budget Review",
//     startDate: new Date("2021-04-27T19:00:00.000Z"),
//     endDate: new Date("2021-04-27T20:35:00.000Z"),
//   },
//   {
//     text: "New Brochures",
//     startDate: new Date("2021-04-27T21:30:00.000Z"),
//     endDate: new Date("2021-04-27T22:45:00.000Z"),
//   },
//   {
//     text: "Install New Database",
//     startDate: new Date("2021-04-28T16:45:00.000Z"),
//     endDate: new Date("2021-04-28T18:15:00.000Z"),
//   },
//   {
//     text: "Approve New Online Marketing Strategy",
//     startDate: new Date("2021-04-28T19:00:00.000Z"),
//     endDate: new Date("2021-04-28T21:00:00.000Z"),
//   },
//   {
//     text: "Upgrade Personal Computers",
//     startDate: new Date("2021-04-28T22:15:00.000Z"),
//     endDate: new Date("2021-04-28T23:30:00.000Z"),
//   },
//   {
//     text: "Customer Workshop",
//     startDate: new Date("2021-04-29T18:00:00.000Z"),
//     endDate: new Date("2021-04-29T19:00:00.000Z"),
//     allDay: true,
//   },
//   {
//     text: "Prepare 2021 Marketing Plan",
//     startDate: new Date("2021-04-29T18:00:00.000Z"),
//     endDate: new Date("2021-04-29T20:30:00.000Z"),
//   },
//   {
//     text: "Brochure Design Review",
//     startDate: new Date("2021-04-29T21:00:00.000Z"),
//     endDate: new Date("2021-04-29T22:30:00.000Z"),
//   },
//   {
//     text: "Create Icons for Website",
//     startDate: new Date("2021-04-30T17:00:00.000Z"),
//     endDate: new Date("2021-04-30T18:30:00.000Z"),
//   },
//   {
//     text: "Upgrade Server Hardware",
//     startDate: new Date("2021-04-30T21:30:00.000Z"),
//     endDate: new Date("2021-04-30T23:00:00.000Z"),
//   },
//   {
//     text: "Submit New Website Design",
//     startDate: new Date("2021-04-30T23:30:00.000Z"),
//     endDate: new Date("2021-05-01T01:00:00.000Z"),
//   },
//   {
//     text: "Launch New Website",
//     startDate: new Date("2021-04-30T19:20:00.000Z"),
//     endDate: new Date("2021-04-30T21:00:00.000Z"),
//   },
// ];

export const dinnerTime = { from: 12.5, to: 14 };

export const holidays = [
  new Date(2025, 0, 1),
  new Date(2025, 0, 27),
  new Date(2025, 0, 28),
  new Date(2025, 0, 29),
  new Date(2025, 0, 30),
  new Date(2025, 0, 31),
  new Date(2025, 2, 3),
  new Date(2025, 2, 31),
  new Date(2025, 3, 1),
  new Date(2025, 4, 1),
  new Date(2025, 4, 2),
  new Date(2025, 4, 5),
  new Date(2025, 4, 6),
  new Date(2025, 5, 6),
  new Date(2025, 7, 15),
  new Date(2025, 9, 3),
  new Date(2025, 9, 6),
  new Date(2025, 9, 7),
  new Date(2025, 9, 8),
  new Date(2025, 9, 9),
  new Date(2025, 9, 10),
  new Date(2025, 11, 25),
  new Date(2025, 11, 26),
  new Date(2025, 11, 29),
  new Date(2025, 11, 30),
  new Date(2025, 11, 31),
];
